import getEventDurationDisplayString from 'mini-common-utils/lib/utils/getEventDurationDisplayString';
import { CalendarEvent } from 'mini-calendar-event-types';
import { format } from 'owa-strings';
import { formatUserDateTime } from 'owa-datetime';
import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';

const EMPTY_STRING = '';
/**
 * Returns the Aria label for an event for its time and duration
 * @param event
 */
export const getAriaLabelForTimeAndDuration = ({
    Start,
    End,
    IsEffectiveAllDayEvent,
    MultiDayInfo,
}: CalendarEvent): string => {
    const strings = getOwaMiniCommonStrings();

    const occurrenceCountString = MultiDayInfo
        ? format(
              strings.calendarSurfaceItemOccurenceCountAriaLabel,
              MultiDayInfo.MultiDayEventInstance,
              MultiDayInfo.TotalEventInstances
          )
        : EMPTY_STRING;

    return format(
        strings.eventDateAndTimeAriaLabel,
        formatUserDateTime(Start),
        formatUserDateTime(End),
        getEventDurationDisplayString(Start, End),
        IsEffectiveAllDayEvent ? strings.eventIsAllDayEventAriaDescriptor : EMPTY_STRING,
        occurrenceCountString
    );
};
